export default "__VITE_ASSET__DsuU_kl7__"